import React from "react";
import { SignedIn } from "@/components/auth/SignedIn";
import SignIn from "@/components/auth/SignIn";
import { SignInFlowType } from "@/components/auth/SignInFlowTypes";
import { ActivityTracker } from "@/components/ActivityTracker";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  return (
    <SignedIn fallback={<SignIn flowType={SignInFlowType.LOGIN} />}>
      <ActivityTracker />
      {children}
    </SignedIn>
  );
};

export default ProtectedRoute;
